import {svgIconWrapper} from '../svg-icon-wrapper';

import HousecallProRegular from './housecall-pro-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <HousecallProRegular {...props} />;
}

SvgComponent.iconName = 'housecallProRegular';

export const HousecallProRegularIcon = svgIconWrapper(SvgComponent);
